import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Image, Row, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { TimeRangePickerProps } from 'antd/lib';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { setModal } from '../../../common/slices/commonSlice';
import { perProps } from '../../../common/types/commonTypes';
import { debounce } from '../../../common/utils/common.utils';
import usePagination from '../../../common/utils/usePagination';
import useUrlParams from '../../../common/utils/useUrlParams';
import CommonTableHeader from '../../../components/common/CommonTableHeader';
import { FormInput } from '../../../components/common/FormItem/FormItems';
import BreadCrumb from '../../../components/common/breadCrumb/BreadCrumb';
import Reload from '../../../components/common/reload/Reload';
import { loadingIndicator } from '../../../components/common/spinner/LoadingIndicator';
import { formatDateRangeArray, parseDateRangeObject } from '../../../helpers/healper';
import {
  useDeletePassportMutation,
  useGetAllPassportQuery,
} from '../Api/Endpoints/PassportEndpoints';
import PassportStatusModal from '../Modals/Passport_Status/PassportStatusModal';
import { IPassportDataType } from '../PassportTypes/PassportTypes';
import { PassportUtils } from '../Utils/PassportUtils';

const All_Passport = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const [file, setFile] = useState<string | null>(null);
  const [filter, setFilter] = useState<string | undefined>('');
  const { setUrlParam, setUrlParamsFromObject, getAllUrlParams } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
    filter_by_name: string | null;
  };
  const src = file as string;
  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    data,
    isFetching,
    refetch: getAllRefetch,
    isLoading: dataIsLoading,
  } = useGetAllPassportQuery({
    ...getAllUrlParams(),
    page,
    size,
  });

  //  DELETE PASSPORT

  const [deleteVendor, { isError, isSuccess, isLoading: deleteLoading }] =
    useDeletePassportMutation();

  const handleDelete = (value: number) => {
    deleteVendor({ id: value });
  };

  const [statusInfo, setStatusInfo] = useState<IPassportDataType | null>(null);
  const handelSearch = useCallback(
    debounce((e: string) => {
      setUrlParam('search', e);
    }, 600),
    []
  );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search || '',
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
      filter: params_value.filter_by_name,
    });
  }, [params_value]);
  const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Today', value: [dayjs(), dayjs()] },
    { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs()] },
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
  ];
  // Add safety check for data mapping
  const dataWithKey =
    data?.data?.map((item, index) => ({
      key: String(index),
      ...item,
    })) || [];
  return (
    <div>
      <BreadCrumb arrOfOption={['Passport']} reloaderSize='small' />
      <Row justify={'space-between'} align={'middle'}>
        <Col span={12}>
          <Row gutter={10}>
            {permission?.['create:any'] && (
              <Col xs={24} sm={12} md={8} lg={8}>
                <Link to='/passport/add'>
                  <Button type='primary' icon={<PlusOutlined />} style={{ width: '100%' }}>
                    Create
                  </Button>
                </Link>
              </Col>
            )}

            <Col xs={24} sm={12} md={8} lg={8} style={{ display: 'flex' }}>
              <Col>
                <Reload
                  refetch={() => {
                    getAllRefetch();
                  }}
                />
              </Col>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={[10, 10]}>
              {/* <Col xs={24} sm={12} md={8} lg={8}>
                <SelectClients
                  onChange={(e) => setFilter(e as string)}
                  placeholder='Filter by client'
                  name={'filter_by_name'}
                  size={24}
                  mdSize={8}
                  smSize={12}
                  offDropDown
                  showAll
                  allowClear={false}
                />
              </Col> */}
              <Col xs={24} sm={12} md={8} lg={8}>
                <DatePicker.RangePicker
                  name={'date_range'}
                  presets={rangePresets}
                  format={'YYYY-MM-DD'}
                  onChange={(e: any) => setUrlParamsFromObject(formatDateRangeArray(e))}
                />
              </Col>
              <FormInput
                name={'search'}
                placeholder='Search here ...'
                onChange={(e: string) => handelSearch(e.trim())}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      <CommonTableHeader
        element={
          file ? (
            file?.substring(file.indexOf('.')) == '.pdf' ? (
              <iframe
                style={{
                  width: '100%',
                  height: '100%',
                }}
                title='file'
                src={src}
              />
            ) : (
              <Image preview={false} src={src} />
            )
          ) : (
            <></>
          )
        }
        setNull={setFile}
      />
      <div>
        <span style={{ marginLeft: '5px', float: 'left', marginBottom: '1rem' }}>
          You have total <strong>{data?.count || data?.data?.length || 0}</strong> rows.
        </span>
        <Table
          size='small'
          bordered
          pagination={changePagination(data?.count)}
          columns={PassportUtils(
            setFile,
            showModal,
            permission,
            handleDelete,
            deleteLoading,
            pagination,
            setStatusInfo
          )}
          dataSource={dataWithKey}
          scroll={{ x: 'max-content' }}
          loading={{
            spinning: dataIsLoading || isFetching,
            indicator: loadingIndicator,
          }}
        />
      </div>

      {/*passport status update modal */}
      <CommonTableHeader
        title=''
        element={
          statusInfo ? <PassportStatusModal info={statusInfo} setNull={setStatusInfo} /> : <></>
        }
        setNull={setStatusInfo}
      />
    </div>
  );
};

export default All_Passport;
